import { Flex } from "@components/index";
import type React from "react";
import styles from "./RiskLosingDay.module.scss";

interface RiskLosingDayProps {
  riskLevel: Sentinel.Enumerators.TimelineRisk;
}

const RiskLosingDay: React.FC<RiskLosingDayProps> = ({ riskLevel }) => {
  const getRiskText = (level: Sentinel.Enumerators.TimelineRisk): string => {
    switch (level) {
      case "Inactive":
        return "Inativo";
      case "Low":
        return "Baixo";
      case "Medium":
        return "Médio";
      case "High":
        return "Alto";
      default:
        return "-";
    }
  };

  const getContainerClass = (
    level: Sentinel.Enumerators.TimelineRisk
  ): string => {
    switch (level) {
      case "Inactive":
        return `${styles.container} ${styles.containerInactive}`;
      case "Low":
        return `${styles.container} ${styles.containerLow}`;
      case "Medium":
        return `${styles.container} ${styles.containerMedium}`;
      case "High":
        return `${styles.container} ${styles.containerHigh}`;
      default:
        return `${styles.container}`;
    }
  };

  return (
    <Flex
      alignItems="center"
      gap="3px"
      className={getContainerClass(riskLevel)}
    >
      Risco de perder o dia: <b> {getRiskText(riskLevel)}</b>
    </Flex>
  );
};

export default RiskLosingDay;
